import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { HttpService } from '../../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class ConsultarFuncionarioService {

  constructor(private http:HttpService) { }

  buscaFuncionarios(params:any, successHandle:Function, errorHandle:Function) {
     this.http.doGet('/employee?sort=pessoa.nome', params, successHandle, errorHandle);
  }
  
 


}
